var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 19 19",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h19v19h-19z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.50071 19.0014c5.24709 0 9.50069-4.2536 9.50069-9.50069 0-5.2471-4.2536-9.50071-9.50069-9.50071-5.2471 0-9.50071 4.25361-9.50071 9.50071 0 5.24709 4.25361 9.50069 9.50071 9.50069z",
    fill: "#818285"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.50018 2.71387-6.24286 6.78535.96931 1.05418 6.23227-6.79764z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.7646 8.43559-5.25228 5.72821-.78046-.852 5.24774-5.72393.0023-.00217-.9792-1.06508-.0007.00145-1.7566-1.91569-.0023.00217-.0023-.00217-6.2322 6.79692.97993 1.0644 5.25457-5.73117.7812.85134-5.2538 5.73043.97992 1.0643.00379-.0043.78046.8521-.00228.0029.96779 1.052 6.24282-6.78608z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInp);
export default __webpack_public_path__ + "static/media/inp.308b4f395146014289597395242ea7b0.svg";
export { ForwardRef as ReactComponent };